/**
 * Labstep
 *
 * @module components/Protocol/Action/Duplicate
 * @desc Duplicate Button. On clicking it show a confirmation dialog.
 * If confrimed it creates a new protocol collection with a copy of
 * this protocol as its child and then redirects the user to the
 * newly created protocol
 */

import { CanCreate } from 'labstep-web/components/Entity/Can';
import { ProtocolFormDuplicateCreateContainer as ProtocolFormDuplicate } from 'labstep-web/components/Protocol/Form/Duplicate';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as DefaultModal } from 'labstep-web/core/Modal/Default';
import type { Protocol } from 'labstep-web/models/protocol.model';
import { navigation } from 'labstep-web/services/navigation';
import type React from 'react';
import { withRouter } from 'react-router-dom';
import type { IProtocolActionDuplicateProps } from './types';

export const ProtocolActionDuplicate: React.FC<
  IProtocolActionDuplicateProps
> = ({
  protocol: entity,
  history,
  actionComponentProps,
  isTemplate,
  header,
}) => (
  <CanCreate entityName="protocol_collection">
    <DefaultModal
      header={header || 'Duplicate Protocol'}
      viewComponent={({ toggleModal }) => (
        <ActionComponent
          type="option"
          icon="clone"
          text="Duplicate"
          {...actionComponentProps}
          onClick={toggleModal}
        />
      )}
      content={() => (
        <ProtocolFormDuplicate
          parent={entity}
          isTemplate={isTemplate}
          options={{
            onSuccess: ({ response }) => {
              if (!response) {
                return;
              }
              const protocol =
                response.entities.protocol[response.result as any];
              const protocolCollectionId = (protocol as Protocol)
                .collection;
              history.push(
                navigation.get('protocol_collection_show', {
                  id: protocolCollectionId,
                }),
              );
            },
          }}
        />
      )}
    />
  </CanCreate>
);

export default withRouter(ProtocolActionDuplicate);
